"use client";

import dynamic from "next/dynamic";
import {Spinner} from "@heroui/react";

// Load the player (and its hls.js dependency) only in the browser. Keeping
// this out of the server render graph prevents the hls.js chunk from being
// traced into the Cloudflare worker bundle, which would otherwise inflate it.
const App = dynamic(() => import("./fe"), {
    ssr: false,
    loading: () => (
        <div className="flex flex-col items-center justify-center min-h-[300px] gap-4">
            <Spinner size="lg" color="primary"/>
            <p className="text-gray-500">Loading video...</p>
        </div>
    ),
});

export default function PlayLoader() {
    return <App/>;
}
